export const LIST_SALES = 'LIST_SALES';
export const LIST_SALES_LOADING = 'LIST_SALES_LOADING';
export const CLEAN_SALES = 'CLEAN_SALES';
export const CREATE_PIBOX = 'CREATE_PIBOX';
export const LIST_SHOPIFY_STORES = 'LIST_SHOPIFY_STORES';
export const CREATE_PIBOX_SHOPIFY = 'CREATE_PIBOX_SHOPIFY';
export const LIST_WOOCOMMERCE_STORES = 'LIST_WOOCOMMERCE_STORES'
export const LIST_MERCADOFLEX_STORES = 'LIST_MERCADOFLEX_STORES'
export const GO_TO_FILE = 'GO_TO_FILE'